module.exports = function secondsToTime(rawSeconds) {
  var hours = Math.floor(rawSeconds / 3600) % 24;
  var minutes = Math.floor(rawSeconds / 60) % 60;
  var seconds = Math.floor(rawSeconds % 60);
  return {
    hours: hours,
    minutes: minutes,
    seconds: seconds
  };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@uppy/utils/lib/secondsToTime.js
// module id = 1168
// module chunks = 0